// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33G4j","left":"styles_left__1yEO9","desktopActions":"styles_desktopActions__1DlzE","title":"styles_title__1pL-T"};